// extracted by mini-css-extract-plugin
module.exports = {"headerActions":"CompanyMasterPage_headerActions__1rGyX"};